import { render, staticRenderFns } from "./LegacyUserFormImport.vue?vue&type=template&id=e0ef0fec&"
import script from "./LegacyUserFormImport.vue?vue&type=script&lang=js&"
export * from "./LegacyUserFormImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports